import CourseCreate from "@/controllers/course/course-create";
import axios from "axios";

export default {
    extends: CourseCreate,
    data() {
        return {
            courseData: {
                class_id: null,
                teacher_id: this.auth('teacher').check() ? this.$store.state.user.id : null,
                subject_id: null,
                unit: '',
                lesson: '',
                send_date: '',
                img_paths: '',
            },
        }
    },

    methods: {
        getClass($yearId) {
            if (!$yearId || Number($yearId) === 0) {
                this.classArr = [{
                    id: 0,
                    text: 'Select Class'
                }];
                this.noClassMsg = '';
                this.isLoading = false;
                return;
            }

            if (this.auth('teacher').check()) {
                axios.get("/teacher/getGradeAndClass/" + this.$store.state.user.id, {
                    params: {
                        campus_id: this.$store.state.user.campus_id,
                    }
                })
                .then(res => {
                    let $defaultSelectOption = [{
                        id: 0,
                        text: 'Select Class'
                    }];
                    let classList = res.data || [];
                    this.classArr = $defaultSelectOption.concat(classList);
                    this.noClassMsg = this.classArr.length > 1 ? '' : 'There is no class to show.';
                    this.isLoading = false;
                }).catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                });
                return;
            }
            axios.get("class/classList/" + $yearId, {
                params: {
                    campus_id: this.$store.state.user.campus_id,
                }
            })
                .then(res => {
                    let $defaultSelectOption = [{
                        id: 0,
                        text: 'Select Class'
                    }];
                    this.classArr = $defaultSelectOption.concat(res.data);
                    this.noClassMsg = this.classArr.length > 1 ? '' : 'There is no class to show.';
                    this.isLoading = false;
                }).catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        },
        getTeacher($class_id) {
            if (this.auth('teacher').check()) {
                this.courseData.teacher_id = this.$store.state.user.id;
                this.getSubject(this.courseData.teacher_id, $class_id);
                return;
            }

            this.teacher_id = 0;
            this.subject_id = 0;
            axios.get('/teacher/getTeacherByClass/' + $class_id)
                .then(res => {
                    let $defaultSelectOption = [{
                        'id': 0,
                        'text': 'Select Teacher'
                    }];
                    this.teacherArr = $defaultSelectOption.concat(res.data);
                    this.isLoading = false;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        },
        changeClassEvent($class_id) {
            this.courseData.teacher_id = 0;
            this.courseData.subject_id = 0;
            this.getTeacher($class_id);
        },
        changeAcademicYearEvent($acd_year_id) {
            this.courseData.class_id = 0;
            this.courseData.teacher_id = 0;
            this.courseData.subject_id = 0;
            this.noClassMsg = '';
            this.teacherLocked = false;
            this.getClass($acd_year_id);
        },
        teacherDisplayName() {
            return this.$store.state.user?.name || 'Teacher';
        },
    },
}
